/**
 * Created by Ning Jiang on 10/10/2018.
 */

import {Linear, Power2, Timeline, TimelineLite, TweenLite} from "gsap";
import {MonkeysGoldInitialWinCountUp} from "./MonkeysGoldInitialWinCountUp";
import {MonkeysGoldInitialWPView} from "./MonkeysGoldInitialWPView";
import {SequentiallyBetWayInitialWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/initial/sequentially/SequentiallyBetWayInitialWPController";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {MonkeysGoldGameConfig} from "../../MonkeysGoldGameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {MonkeysGoldParsedGameData} from "../../server/data/MonkeysGoldParsedGameData";
import {IWinRatioConfig, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {MonkeysGoldSoundConfig} from "../../MonkeysGoldSoundConfig";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {MonkeysGoldGameModuleConfig} from "../../MonkeysGoldGameModuleConfig";
import {IMonkeysGoldBetWayWinData} from "../individualwin/MonkeysGoldWaysWonGFXText";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {MGIndividualWinAmountView} from "./MGIndividualWinAmountView";
import {MonkeysGold} from "../../MonkeysGold";

export class MonkeysGoldInitialWPController extends SequentiallyBetWayInitialWPController {

    private _gameView:MonkeysGoldInitialWPView;
    private _winCountUp:MonkeysGoldInitialWinCountUp;
    protected _betWinsData:IMonkeysGoldBetWayWinData[] | null;
    private _currentWinRatioConfig:IWinRatioConfig;
    private _allWinPositions:boolean[][];
    private _winAnimationMainTL:TimelineLite;
    private _countUpStyle:BitmapTextStyleOptions = {
        font : {
            name : "NumbersWinCountUp",
            size : 50
        }
    };
    private _countUpTimeline:TimelineLite;
    private _countUpStopSoundPlayed:boolean = false;
    private _isFastWin:boolean;
    private _mode:string;
    private _belowStakeWinRestriction:boolean;
    private _individualWinView:MGIndividualWinAmountView;

    constructor(indexes:[number, number]) {
        super(indexes);
        this._gameView = new MonkeysGoldInitialWPView();
        this._winCountUp = new MonkeysGoldInitialWinCountUp(this._countUpStyle);
        this._winCountUp.position.set(360, GameConfig.instance.GAME_HEIGHT * 0.55);
        this._individualWinView = new MGIndividualWinAmountView();
        StageManager.getLayer(MonkeysGoldGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this._individualWinView,this._winCountUp);
    }

    protected parseFeatureGameData(data:MonkeysGoldParsedGameData):void {
        this._currentWinRatioConfig = data.currentWinRatioConfig!;
        const winType:WinRatioType = data.currentWinRatioConfig!.type!;
        this._isFastWin = winType === WinRatioType.TINY || winType === WinRatioType.SMALL;
        if(this.hasWin()) {
            this._allWinPositions = data.allWinPositions;
        }
        this._mode = data.mode;

        this._belowStakeWinRestriction = SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (data.singleWin <= data.playedBetValue);
    }

    protected addWinCountUpToTimeline(timeline:Timeline):void {
        if(this._gameData!.isBigWin) {
            return;
        }

        const totalWin:number = this._gameData!.totalWin;
        const from:number = totalWin - this._gameData!.singleWin;
        const duration:number = this._gameData!.currentWinRatioConfig!.duration;

        this._countUpTimeline = new TimelineLite();
        this._countUpTimeline.add(() => this._countUpStopSoundPlayed = false);
        this._countUpTimeline.add(() => this._winCountUp.alpha = 0, "+=0.1");
        this._countUpTimeline.add(() => this._winCountUp.scale.set(0, 0));
        this._countUpTimeline.add([
            new TweenLite(this._winCountUp.scale, 0.3, {
                x : this.getWinTypeScale(this._currentWinRatioConfig.type!),
                y : this.getWinTypeScale(this._currentWinRatioConfig.type!),
                ease : Power2.easeOut
            }),
            new TweenLite(this._winCountUp, 0.2, {alpha : 1, ease : Linear.easeOut}),
            () => this._winCountUp.currentWinRatio = this._currentWinRatioConfig.type!,
            () => {
                if(duration > 0) {
                    (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.COUNTUP)});
                }
            },
            this._winCountUp.getCountUpAnimation(0, this._gameData!.singleWin, duration, this._gameData!.currentMultiplier, this._currentWinRatioConfig.type!)
        ]);
        if((this._mode == GameMode.NORMAL || this._mode == GameMode.NORMAL_AVALANCHE) && (this._currentWinRatioConfig.type! == WinRatioType.LARGE || this._currentWinRatioConfig.type! == WinRatioType.MEDIUM)) {
            if(this._currentWinRatioConfig.type! == WinRatioType.LARGE) {
                this._countUpTimeline.add([
                    new TweenLite(this._winCountUp.scale, 0.2, {
                        x : 1.9,
                        y : 1.9,
                        ease : Power2.easeOut
                    }),
                    () => (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.COUNTUP_ENDS_SWEEP)})
                ]);
            } else {
                this._countUpTimeline.add([
                    new TweenLite(this._winCountUp.scale, 0.2, {
                        x : 1.6,
                        y : 1.6,
                        ease : Power2.easeOut
                    }),
                    () => (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.COUNTUP_ENDS_SWEEP)})
                ]);
            }

            this._countUpTimeline.add(
                new TweenLite(this._winCountUp.scale, 0.1, {
                    x : this.getWinTypeScale(this._currentWinRatioConfig.type!),
                    y : this.getWinTypeScale(this._currentWinRatioConfig.type!),
                    ease : Power2.easeOut
                })
            );
        }
        this._countUpTimeline.add(() => {
            if(duration > 0) {
                (<INolimitAudioPlayer>SlotGame.sound).stopTrack(MonkeysGoldSoundConfig.instance.COUNTUP);
            }
            if (this._gameData!.currentMultiplier == 1){
                if (!this._belowStakeWinRestriction){
                    (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : this.getCountupStopSound(this._currentWinRatioConfig.type!)});
                }
            }
            this._countUpStopSoundPlayed = true;
        });
        timeline.add(this._countUpTimeline, 0);
    }

    protected addWinAnimationsToTimeline(timeline:Timeline):void {
        let startTime: number = 0;

        if (this._winAnimationMainTL && this._winAnimationMainTL.isActive()) {
            this._winAnimationMainTL.pause();
            this._winAnimationMainTL.kill();
        }

        this._winAnimationMainTL = new TimelineLite();

        if (MonkeysGold.api.gameClientConfiguration.displayIndividualWinsInGame) {
            this._winAnimationMainTL.add(() => {
                this._individualWinView.displayIndividualBetLineAmount(this._betWinsData!);
            });
        }
        //Add a small delay so Big Win has time to finish
        if(this._gameData!.isBigWin) {
            this._winAnimationMainTL.add(new TimelineLite({delay : 1}));
        }


        if (!this._belowStakeWinRestriction){
            this._winAnimationMainTL.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (this.getWinTypeSound(this._currentWinRatioConfig.type!))}));


            let delay:number = 0;
            let tempSymName:string;
            for(let i:number = 0; i < this._allWinPositions.length; i++) {
                const reelWinAnimations:TimelineLite[] = [];
                for(let j:number = 0; j < this._allWinPositions[i].length; j++) {
                    if(this._allWinPositions[i][j] == true) {
                        tempSymName = Reels.getSymbol(i, j)!.symName;
                        if(tempSymName == "W_hidden") {
                            tempSymName = "W";
                        }
                        if(tempSymName.indexOf("hidden") == -1 && tempSymName !== "S") {
                            if(tempSymName.indexOf("x2") > -1) {
                                reelWinAnimations.push(this._gameView.getSymbolInitialWinTL(i, j, 2));
                            } else if(tempSymName.indexOf("x3") > -1) {
                                reelWinAnimations.push(this._gameView.getSymbolInitialWinTL(i, j, 3));
                            } else {
                                reelWinAnimations.push(this._gameView.getSymbolInitialWinTL(i, j, 1));
                            }
                        }
                    }
                }
                if(i > 0) {
                    delay = 0.58;
                }
                this._winAnimationMainTL.add(reelWinAnimations, "-=" + delay);
            }
        }

        this._winAnimationMainTL.add(() => MonkeysGoldGameModuleConfig.monkeysGoldScatterLandView.cleanUpAllScatters());

        timeline.add([
            this._winAnimationMainTL
        ]);
    }

    private getCountupStopSound(winType:WinRatioType):string {
        switch(winType) {
            case WinRatioType.LARGE :
                return MonkeysGoldSoundConfig.instance.COUNTUP_ENDS_LARGE;

            case WinRatioType.MEDIUM :
                return MonkeysGoldSoundConfig.instance.COUNTUP_ENDS_MEDIUM;

            case WinRatioType.SMALL :
                return MonkeysGoldSoundConfig.instance.COUNTUP_ENDS_SMALL;

            case WinRatioType.TINY :
                return MonkeysGoldSoundConfig.instance.COUNTUP_ENDS_TINY;

            default :
                return "";
        }
    }

    private getWinTypeSound(winType:WinRatioType):string {
        switch(winType) {
            case WinRatioType.BIG_WIN :
                return MonkeysGoldSoundConfig.instance.BIG_WIN_INITIAL_WIN;

            case WinRatioType.MEGA_WIN :
                return MonkeysGoldSoundConfig.instance.BIG_WIN_INITIAL_WIN;

            case WinRatioType.SUPER_MEGA_WIN :
                return MonkeysGoldSoundConfig.instance.BIG_WIN_INITIAL_WIN;

            case WinRatioType.LARGE :
                return MonkeysGoldSoundConfig.instance.WIN_SWEEP_LARGE;

            case WinRatioType.MEDIUM :
                return MonkeysGoldSoundConfig.instance.WIN_SWEEEP_MEDIUM;

            case WinRatioType.SMALL :
                return MonkeysGoldSoundConfig.instance.WIN_SWEEP_TINY_SMALL;

            case WinRatioType.TINY :
                return MonkeysGoldSoundConfig.instance.WIN_SWEEP_TINY_SMALL;

            default :
                return "";
        }
    }

    private getWinTypeScale(winType:WinRatioType):number {
        switch(winType) {
            case WinRatioType.LARGE :
                return 1.10;

            case WinRatioType.MEDIUM :
                return 1.05;

            case WinRatioType.SMALL :
                return 1;

            case WinRatioType.TINY :
                return 0.95;

            default :
                return 1;
        }
    }

    protected getNextBetWinAnimationTimeOffset(lastSymbolDelay:number):number {
        return lastSymbolDelay;
    }

    protected getNextSymbolAnimationTimeOffset(duration:number):number {
        return duration;
    }

    protected stopWinPresentation(isAborted:boolean):void {
        super.stopWinPresentation(isAborted);
        if(this._countUpTimeline && this._countUpTimeline.isActive()) {
            this._countUpTimeline.pause();
            this._countUpTimeline.kill();
        }
        if(this._gameData!.isBigWin == false) {
            SlotGame.winFieldController.showWinField();
        }
        this._individualWinView.individualLineAmountReset();
        this._winCountUp.alpha = 1;
        this._winCountUp.scale.set(this.getWinTypeScale(this._currentWinRatioConfig.type!), this.getWinTypeScale(this._currentWinRatioConfig.type!));
        this._winCountUp.abort(this._gameData!.singleWin, isAborted, this._gameData!.currentMultiplier, this._gameData!.isBigWin);
        this._gameView.abort();
        if(isAborted == true) {
            this._gameView.cleanupSpineWinSymbols();
            (<INolimitAudioPlayer>SlotGame.sound).stopTrack(MonkeysGoldSoundConfig.instance.COUNTUP);
            if(this._countUpStopSoundPlayed == false) {
                if (!this._belowStakeWinRestriction){
                    (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (this.getCountupStopSound(this._currentWinRatioConfig.type!))});
                }
            }
        }
        if(SlotGame.autoPlay.isAutoplayRound) {
            this._gameView.cleanupSpineWinSymbols();
        }
    }
}